
import { UI } from './ui.js'
export class Transl {
    constructor() {
        window.ui = window.ui ? window.ui : new UI()
        window.__ = this.transl
        fetch('/transl').then(response => response.text()).then(text => {
            window.translations = JSON.parse(text)
        })
    }

   
    transl(transl) {
        if(typeof window.translations !== 'undefined') {
            
            return window.translations[transl] ? window.translations[transl] : transl
        }else{
            return this.transl(transl)
        }
            
        
        
    }
}